import { DatePicker } from '@mui/x-date-pickers'
import React, { useState } from 'react'
import dayjs from 'dayjs';
import { MenuItem, Select } from '@mui/material';

function DateSelector(props) {
    const { selectedStartDate, setSelectedStartDate } = props;
    const { selectedEndDate, setSelectedEndDate } = props;

 
    const [currentRange, setCurrentRange] = useState('currentMonth');

    function rangeChange(newValue) {

        const date = new Date()
        const y = date.getFullYear()
        const m = date.getMonth();
    
        var firstDay = new Date(y, m, 1);
        var lastDay = new Date(y, m + 1, 0);


        if (newValue.target.value === "currentMonth") {
            setSelectedStartDate(dayjs(firstDay))
            setSelectedEndDate(dayjs(lastDay))
        }
        else if (newValue.target.value === "lastMonth") {
            firstDay = new Date(y, m - 1, 1);
            lastDay = new Date(y, m, 0);


            setSelectedStartDate(dayjs(firstDay))
            setSelectedEndDate(dayjs(lastDay))
        }

        setCurrentRange(newValue.target.value)
    }

    return (
        <div>
            <table>
                <thead>
                    <tr>
                        <td>  
                            Predefined Range:<br></br>
                            <Select value={currentRange} style={{ width: 250 }} onChange={(newValue) => { rangeChange(newValue) }}>
                                <MenuItem value="currentMonth">Current Month</MenuItem>
                                <MenuItem value="lastMonth">Last Month</MenuItem>
                            </Select>

                        </td>
                        <td>
                            Start Date: <br></br>
                            <DatePicker value={selectedStartDate} onChange={(newValue) => setSelectedStartDate(newValue)} />

                        </td>
                        <td>
                            End Date<br></br>
                            <DatePicker value={selectedEndDate} onChange={(newValue) => setSelectedEndDate(newValue)} />

                        </td>
                    </tr>
                </thead>
            </table>
            <br></br>

        </div>
    )
}

export default DateSelector